import { emailAndPhoneRegex } from "../../constants/constants";

export const delimiter = [
  {
    value: "pipe",
    label: "Pipe",
  },
  {
    value: "comma",
    label: "Comma",
  },
];
export const fileUploadOptions = [
  {
    value: "pipe",
    label: "Pipe ( | ) separated .txt file",
  },
  {
    value: "comma",
    label: "Comma ( , ) separated .txt or .csv file",
  },
  {
    value: "commaSeparatedValues",
    label: "Comma (,) separated text values",
  },
];
export const directTextInputValidation = (values) => {
  const text = values.commaSeparatedText || "";
  const hiddenCharactersRemovedValue = text
    .replace(/[\u200B-\u200D\uFEFF\u202A-\u202E\u2066-\u2069\u00A0]|[^\x20-\x7E\n\r\t]+/g, "")
  values.commaSeparatedText = hiddenCharactersRemovedValue;
  let error = "";
  if (!hiddenCharactersRemovedValue) {
    error = "Values are required.";
  } else if (hiddenCharactersRemovedValue?.split(",")?.length > 50) {
    error = "You can’t add more than 50 phone numbers through direct input.";
  } else if (!Boolean(emailAndPhoneRegex.test(hiddenCharactersRemovedValue))) {
    error =
      "Phone number minimum length is 10 and it should contain only numbers.";
  } else if (
    hiddenCharactersRemovedValue[hiddenCharactersRemovedValue.length - 1] ===
    ","
  ) {
    error = "Please add one more number or remove the comma.";
  }
  return error;
};

export const ERRORS = {
  TEMPLATE: {
    NAME_EXISTS: "Template name already exists.",
    CHECK_NAME_API_ERROR: "Error while checking template name.",
  },
};
